import React from 'react';
import { Container } from 'reactstrap';
import MetaTags from 'react-meta-tags';

import { Form } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  AagencyLogin,
  GetAagencyUserDetails,
  GetRolePermissions
} from '../../apis/Agency';
import { ErrorToast } from '../../components/Toasts';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { useDispatch } from 'react-redux';
import {
  setPasswordRedux,
  setEmailRedux,
  setUserToken,
  setLoginAgencyID,
  setIsAdmin,
  setUserDetailsObj,
  setUserRolePermissionsArr,
  setAgencyAdminDetails,
  setRememberMeRedux,
  setUserColumnOrder,
  setUserColumnVisibility
} from '../../Redux/UserSlice';
import './Common.css';

//M-Imports
// import  Box  from '@mui/material/Box';
import {
  Typography,
  TextField,
  FormControlLabel,
  IconButton,
  Checkbox,
  Button,
  InputAdornment,
  Grid
} from '@mui/material';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './Login.css';
import { useSelector } from 'react-redux';
import { base_url, base_logo_url } from '../../apis/constants';
import { useCookies } from 'react-cookie';
import { setRateValues } from '../../Redux/GetRatesSlice';
import {
  setQuickQuoteRateLoc,
  setQuickQuoteRateValues,
  setQuickQuoteTLRateValues
} from '../../Redux/QuickQuoteRateSlice';

const SignIn = props => {
  const rememberMeRedux = useSelector(state => state.userDetails.rememberMe);
  const rememberMePassword = useSelector(state => state.userDetails.password);
  const rememberMeEmail = useSelector(state => state.userDetails.email);
  const [showCORSModal] = useState(false);
  useCookies(['userInfo']);
  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();
  const [isLoading, setIsLoading] = useState(false);

  // M-Hooks
  const [isMailError, setIsMailError] = useState(false);
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [mailError, setMailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword(show => !show);

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  let history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    if (rememberMeRedux && !userName && !password) {
      setUserName(rememberMeEmail);
      setPassword(rememberMePassword);
    }
  }, [rememberMeRedux]);

  const handleGetUserPermissionsRequest = apiRes => {
    const levels = ['level1', 'level2', 'level3', 'level4', 'level5'];

    GetRolePermissions(apiRes.data.userInfo.roleId)
      .then(res => {
        res.status === 200 &&
          dispatch(
            setUserRolePermissionsArr(
              res.data?.data[0]?.permissions?.length > 0
                ? JSON.parse(res.data.data[0]?.permissions)
                : res.data.data
            )
          );
        const hasAnyLevelTrue = res.data.data.some(permission =>
          levels.some(level => permission[level])
        );
        setTimeout(() => {
          window.location.reload();
        }, 1);
        if (apiRes.data.isAdmin) {
          history.push({
            pathname: '/manage-shipments',
            state: { selectedTab: 'Booked', callAPI: 'no' }
          });
        } else if (res.data.data.length === 0) {
          history.push({
            pathname: '/manage-shipments',
            state: { selectedTab: 'Booked', callAPI: 'no' }
          });
        } else if (!hasAnyLevelTrue) {
          history.push('/no-module-assigned');
        } else {
          history.push('/');
        }
      })
      .catch(err => {
        console.log(err, 'user permissions Err----->>>>');
      });
  };

  const GetSuccessUserDetails = apiRes => {
    dispatch(setIsAdmin(apiRes.data.isAdmin));
    dispatch(setUserDetailsObj(apiRes.data));
    dispatch(setUserColumnOrder(apiRes.data.userSettings.SHIPMENT_GRID_ORDER));
    dispatch(
      setUserColumnVisibility(apiRes.data.userSettings.SHIPMENT_GRID_COLUMNS)
    );
    dispatch(
      setAgencyAdminDetails({
        userAvatar: apiRes.data.userInfo.avatar,
        agencyName: apiRes.data.agencyName
      })
    );
    handleGetUserPermissionsRequest(apiRes);
  };

  const successResponse = succRes => {
    if (succRes.statusCode === 200) {
      dispatch(setPasswordRedux(password));
      dispatch(setEmailRedux(userName));
      dispatch(setUserToken(succRes.token));
      dispatch(setLoginAgencyID(succRes.agencyId));

      sessionStorage.setItem('UserAuthToken', succRes.token);
      localStorage.setItem('tokenExpiryTime', succRes.expiry);
      document.cookie = 'userInfo=John Doe; path=/';

      GetAagencyUserDetails(userName)
        .then(res => {
          res.data.statusCode === 200 && GetSuccessUserDetails(res.data);
        })
        .catch(err => console.log(err));
    }
  };

  const handleRememberMe = e => {
    dispatch(setRememberMeRedux(e.target.checked));
  };

  const handleSubmit = e => {
    e.preventDefault();

    setIsMailError(false);
    setMailError('');
    setIsPasswordError(false);
    setPasswordError('');
    dispatch(setUserDetailsObj({}));
    dispatch(setRateValues(''));
    dispatch(setQuickQuoteRateValues(''));
    dispatch(setQuickQuoteRateLoc(''));
    dispatch(setQuickQuoteTLRateValues(''));
    setIsLoading(true);
    dispatch(setPasswordRedux(password));

    AagencyLogin(userName, password)
      .then(res => successResponse(res.data))
      .catch(err => {
        setIsLoading(false);

        if (err?.response?.status === 401) {
          ErrorToast(
            'Invalid email or password. Please check your credentials.'
          );
        } else if (err?.response?.status === 404) {
          ErrorToast(err?.response?.data?.message);
        } else if (err?.response?.status === 500) {
          ErrorToast('Internal server error. Please try again later.');
        } else if (err?.response?.status === 403) {
          ErrorToast('Access forbidden. Please contact administrator.');
        } else if (
          err?.code === 'ERR_NETWORK' ||
          err?.message?.includes('CORS')
        ) {
          console.log('Network/CORS error detected - modal will appear');
        } else if (err?.response?.data?.message?.includes('User')) {
          setIsMailError(true);
          setMailError(err?.response?.data?.message);
        } else {
          ErrorToast(
            err?.response?.data?.message ||
              'An error occurred during login. Please try again.'
          );
        }
      });
  };

  return (
    <React.Fragment>
      <ToastContainer
        position='top-center'
        style={{ width: 'auto' }}
        autoClose={4800}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {console.log(showCORSModal, 'showCORSModal')}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundImage: `url(${base_logo_url}carrier_logos/TMS-backg-img.png)`,
          backgroundSize: '100% 110%',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0
        }}
      />
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div className=''>
          <div className=''>
            <MetaTags>
              <title>Sign In | TMS Shipping</title>
            </MetaTags>
            <section
              style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Container fluid>
                <Grid
                  container
                  sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: { xs: 2, sm: 4 }
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={7}
                    md={5}
                    lg={4}
                    xl={3}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: 'rgba(255,255,255,0.97)',
                      borderRadius: '16px',
                      boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                      padding: { xs: '32px 20px', sm: '48px 36px' },
                      minHeight: '410px'
                    }}
                  >
                    <div style={{ width: '100%' }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: -20
                        }}
                      >
                        <svg
                          width='240'
                          height='62'
                          viewBox='0 0 1080 360'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <defs>
                            <linearGradient
                              id='loginLogoGrad'
                              x1='82'
                              y1='72'
                              x2='288'
                              y2='278'
                              gradientUnits='userSpaceOnUse'
                            >
                              <stop offset='0' stopColor='#1297FF' />
                              <stop offset='1' stopColor='#006CFF' />
                            </linearGradient>
                          </defs>
                          <g
                            transform='translate(38 20) scale(.625)'
                            stroke='url(#loginLogoGrad)'
                            strokeWidth='54'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            fill='none'
                          >
                            <path d='M176 108 L256 188 L336 108' />
                            <path d='M108 176 L188 256 L108 336' />
                            <path d='M336 404 L256 324 L176 404' />
                            <path d='M404 336 L324 256 L404 176' />
                          </g>
                          <text
                            x='365'
                            y='220'
                            fill='#000000'
                            fontFamily='Inter, Arial, Helvetica, sans-serif'
                            fontSize='118'
                            letterSpacing='-4'
                          >
                            <tspan fontWeight='700'>Ship</tspan>
                            <tspan fontWeight='400'>TechPro</tspan>
                          </text>
                        </svg>
                      </div>{' '}
                      <div class='w-100'>
                        <Typography variant='h5' class='login-welcome'>
                          Welcome Back
                        </Typography>
                      </div>
                      <Typography
                        variant='body2'
                        style={{
                          textAlign: 'center',
                          color: '#666',
                          marginBottom: '28px'
                        }}
                      >
                        Enter your login information
                      </Typography>
                      <Form style={{ width: '100%' }}>
                        <div style={{ marginBottom: '16px' }}>
                          <Typography
                            variant='caption'
                            style={{ fontWeight: 600, color: '#333' }}
                          >
                            Email <span style={{ color: 'red' }}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            error={isMailError}
                            id='username'
                            value={userName}
                            onChange={e => setUserName(e.target.value)}
                            placeholder='Enter your email'
                            variant='outlined'
                            size='small'
                            required
                            helperText={mailError}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position='start'>
                                  <EmailOutlinedIcon
                                    style={{ color: '#aaa', fontSize: 20 }}
                                  />
                                </InputAdornment>
                              )
                            }}
                            style={{ marginTop: '6px' }}
                          />
                        </div>

                        <div style={{ marginBottom: '16px' }}>
                          <Typography
                            variant='caption'
                            style={{ fontWeight: 600, color: '#333' }}
                          >
                            Password <span style={{ color: 'red' }}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            error={isPasswordError}
                            id='passwordInput'
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder='Enter your password'
                            variant='outlined'
                            size='small'
                            required
                            helperText={passwordError}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position='start'>
                                  <LockOutlinedIcon
                                    style={{ color: '#aaa', fontSize: 20 }}
                                  />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <InputAdornment position='end'>
                                  <IconButton
                                    aria-label='toggle password visibility'
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge='end'
                                    size='small'
                                  >
                                    {showPassword ? (
                                      <VisibilityOff style={{ fontSize: 20 }} />
                                    ) : (
                                      <Visibility style={{ fontSize: 20 }} />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                            style={{ marginTop: '6px' }}
                          />
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'nowrap',
                            marginBottom: '20px',
                            gap: '8px'
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={rememberMeRedux}
                                onClick={e => handleRememberMe(e)}
                                size='small'
                              />
                            }
                            label={
                              <Typography
                                variant='body2'
                                style={{ whiteSpace: 'nowrap' }}
                              >
                                Remember me
                              </Typography>
                            }
                            style={{ margin: 0, flexShrink: 0 }}
                          />
                          <Link
                            to='/agency-resetpassword'
                            style={{
                              color: '#3361FF',
                              fontSize: '13px',
                              textDecoration: 'none',
                              whiteSpace: 'nowrap',
                              flexShrink: 0
                            }}
                          >
                            Forgot your password?
                          </Link>
                        </div>

                        <Button
                          fullWidth
                          disabled={!userName || !password}
                          type='submit'
                          variant='contained'
                          onClick={e => handleSubmit(e)}
                          style={{
                            borderRadius: '8px',
                            padding: '6px',
                            fontSize: '16px',
                            fontWeight: 600,
                            textTransform: 'none'
                          }}
                        >
                          {isLoading ? 'Loading...' : 'Login'}
                        </Button>
                      </Form>
                    </div>
                  </Grid>
                </Grid>
              </Container>

              <div
                style={{ position: 'fixed', bottom: '8px' }}
                className='w-100 px-3'
              >
                <Grid
                  container
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Grid
                    item
                    md={5}
                    lg={5}
                    class='login-footer-cols'
                    style={{ display: 'flex' }}
                  ></Grid>
                  <Grid
                    item
                    md={6}
                    lg={5}
                    class='login-footer-cols'
                    style={{ display: 'flex', justifyContent: 'end' }}
                  >
                    <div class='login-footer-notes'>
                      <span class='login-footer-link1 mx-2'>
                        <div class='d-inline-block'>
                          <EmailOutlinedIcon
                            style={{
                              height: 16,
                              width: 18
                            }}
                          />
                          {base_url === 'https://api.tms.dynamicwerx.com/' ? (
                            <a
                              class='login-footer-link1'
                              href={'mailto:' + 'support@dynamicwerx.com'}
                            >
                              support@dynamicwerx.com
                            </a>
                          ) : (
                            <a
                              class='login-footer-link1'
                              href={'mailto:' + 'support@shiptechpro.com'}
                            >
                              support@shiptechpro.com
                            </a>
                          )}
                        </div>
                      </span>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignIn;
